module.exports = __webpack_public_path__ + "img/lookbook_14_left.a1596d78.png";